var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpcsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.6 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fc0;\n      }\n\n      .st1 {\n        font-size: 4.5px;\n      }\n\n      .st1, .st2, .st3 {\n        fill: #4489c8;\n      }\n\n      .st1, .st3 {\n        font-family: FrutigerNeueLTPro, FrutigerNeueLTPro;\n      }\n\n      .st4, .st5 {\n        fill: none;\n        stroke: #4489c8;\n        stroke-width: .25px;\n      }\n\n      .st5 {\n        stroke-miterlimit: 10;\n      }\n\n      .st6 {\n        fill: red;\n      }\n\n      .st3 {\n        font-size: 2.75px;\n      }\n\n      .st7 {\n        fill: #acc1e5;\n      }\n\n      .st8 {\n        display: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Logo1",
    "data-name": "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 36.95,
    y: 41.68,
    width: 56.69,
    height: 56.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "63.72 67.11 63.72 56.64 52.46 56.64 52.46 64.59 44.82 64.59 44.82 75.46 52.46 75.46 52.46 83.41 63.72 83.41 63.72 72.94 61.04 72.94 61.04 80.89 55.14 80.89 55.14 72.94 47.5 72.94 47.5 67.11 55.14 67.11 55.14 59.16 61.04 59.16 61.04 67.11 63.72 67.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.12,66.17c0,1.9-1.57,3.38-3.56,3.38h-3.03v-6.54h3.03c2.07,0,3.56,1.33,3.56,3.15ZM76.87,56.64h-11.57v26.77h7.24v-7.95h4.33c5.32,0,9.45-4.06,9.45-9.3,0-5.28-4.21-9.52-9.45-9.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M108.36,61.83c-.29-.12-.55-.2-.79-.24-.23-.04-.46-.07-.68-.07-.38,0-.69.08-.91.22-.22.15-.34.35-.34.6,0,.11.02.21.05.31s.1.18.2.27c.1.09.23.17.4.26.17.09.39.18.65.27.67.24,1.15.53,1.45.86.3.34.45.77.45,1.3,0,.34-.06.66-.19.94-.13.28-.31.52-.54.71-.23.2-.52.35-.86.45-.34.11-.71.16-1.12.16-.67,0-1.31-.11-1.91-.31l.13-1.27c.31.15.61.26.89.32.28.06.55.09.81.09.38,0,.7-.08.94-.23s.37-.38.37-.67c0-.14-.02-.26-.06-.37s-.12-.21-.22-.31c-.11-.1-.25-.19-.43-.28-.18-.09-.41-.19-.68-.29-.64-.24-1.1-.51-1.39-.83-.29-.32-.43-.73-.43-1.24,0-.32.06-.61.19-.86.12-.26.3-.48.53-.66.23-.18.5-.32.82-.42.32-.1.67-.14,1.05-.14.32,0,.62.02.9.06.28.04.56.11.85.2l-.11,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M111.09,67.74l-1.65-5.33h1.47l.79,2.89c.02.08.04.18.07.31s.06.24.08.37c.03.13.05.25.08.37.03.12.05.23.06.32h.02c.01-.09.03-.2.06-.32.03-.12.06-.25.09-.38.03-.13.06-.25.09-.37s.06-.21.08-.29l.76-2.9h1.7l.83,2.89c.02.08.05.18.08.31.03.12.06.24.09.37.03.13.06.25.08.37.03.12.05.23.06.32h.02c.01-.09.03-.2.06-.32.03-.12.06-.25.08-.38s.06-.26.08-.37c.03-.12.05-.21.07-.29l.77-2.9h1.37l-1.64,5.33h-1.7l-.84-3.05c-.05-.17-.1-.38-.14-.63-.05-.25-.09-.46-.12-.64h-.02c-.03.18-.08.39-.14.64-.06.25-.11.46-.16.63l-.84,3.05h-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M119.34,61.4v-1.33h1.38v1.33h-1.38ZM119.34,62.41h1.38v5.33h-1.38v-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M122.01,66.49c.26.12.52.22.77.27.25.06.49.09.73.09s.44-.05.61-.14c.17-.09.26-.24.26-.43,0-.09-.01-.17-.05-.24-.03-.07-.09-.13-.16-.2-.08-.06-.18-.12-.31-.18-.13-.06-.31-.12-.52-.2-.51-.17-.87-.37-1.09-.61-.22-.23-.33-.54-.33-.94,0-.25.05-.48.15-.68s.24-.37.43-.51.41-.25.66-.33c.26-.08.55-.12.86-.12.56,0,1.04.08,1.44.25l-.12,1.04c-.44-.2-.86-.3-1.27-.3-.23,0-.43.05-.58.14-.15.1-.23.23-.23.41,0,.09.02.17.05.23.03.07.08.12.15.17.07.05.17.11.3.16s.28.11.47.17c.23.08.44.16.63.25.19.09.34.2.47.33.13.12.23.27.3.43.07.16.1.36.1.59,0,.28-.05.52-.16.73-.11.21-.26.39-.44.53s-.42.25-.69.33c-.27.07-.56.11-.89.11-.29,0-.57-.02-.84-.07-.27-.05-.54-.12-.8-.21l.07-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M126.62,66.49c.26.12.52.22.77.27.25.06.49.09.73.09s.44-.05.61-.14c.17-.09.26-.24.26-.43,0-.09-.01-.17-.05-.24-.03-.07-.09-.13-.16-.2-.08-.06-.18-.12-.31-.18-.13-.06-.31-.12-.52-.2-.51-.17-.87-.37-1.09-.61-.22-.23-.33-.54-.33-.94,0-.25.05-.48.15-.68s.24-.37.43-.51.41-.25.66-.33c.26-.08.55-.12.86-.12.56,0,1.04.08,1.44.25l-.12,1.04c-.44-.2-.86-.3-1.27-.3-.23,0-.43.05-.58.14-.15.1-.23.23-.23.41,0,.09.02.17.05.23.03.07.08.12.15.17.07.05.17.11.3.16s.28.11.47.17c.23.08.44.16.63.25.19.09.34.2.47.33.13.12.23.27.3.43.07.16.1.36.1.59,0,.28-.05.52-.16.73-.11.21-.26.39-.44.53s-.42.25-.69.33c-.27.07-.56.11-.89.11-.29,0-.57-.02-.84-.07-.27-.05-.54-.12-.8-.21l.07-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M134.18,60.51h1.82c.4,0,.78.03,1.15.09.37.06.69.18.97.34.28.17.5.39.66.68s.25.65.25,1.1-.08.79-.24,1.08c-.16.29-.38.52-.66.69-.27.18-.6.3-.96.37-.37.07-.76.11-1.17.11h-.36v2.75h-1.45v-7.22ZM135.64,63.88h.26c.25,0,.47-.02.68-.05.2-.03.37-.09.52-.18.14-.09.26-.2.34-.35s.12-.34.12-.56c0-.43-.14-.72-.42-.88-.28-.16-.69-.24-1.23-.24h-.26v2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M142.29,62.28c.4,0,.78.07,1.11.2s.63.32.87.56c.24.24.43.54.57.88.13.35.2.73.2,1.15s-.07.79-.2,1.13c-.13.34-.33.63-.57.88-.25.25-.54.43-.89.56-.34.13-.72.2-1.13.2s-.79-.07-1.13-.2-.64-.33-.88-.57-.43-.54-.57-.88c-.14-.34-.21-.72-.21-1.13s.07-.82.21-1.16c.14-.34.33-.64.58-.88s.55-.43.89-.56.73-.2,1.16-.2ZM142.25,63.31c-.41,0-.74.15-.97.46s-.35.75-.35,1.32c0,.52.12.94.36,1.25.24.31.56.47.95.47s.74-.16.98-.47c.24-.31.37-.75.37-1.3s-.12-.98-.36-1.28c-.24-.3-.57-.45-.99-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M145.95,66.49c.26.12.52.22.77.27.25.06.49.09.73.09s.44-.05.61-.14c.17-.09.26-.24.26-.43,0-.09-.01-.17-.05-.24-.03-.07-.09-.13-.16-.2-.08-.06-.18-.12-.31-.18-.13-.06-.31-.12-.52-.2-.51-.17-.87-.37-1.09-.61-.22-.23-.33-.54-.33-.94,0-.25.05-.48.15-.68s.24-.37.43-.51.41-.25.66-.33c.26-.08.55-.12.86-.12.56,0,1.04.08,1.44.25l-.12,1.04c-.44-.2-.86-.3-1.27-.3-.23,0-.43.05-.58.14-.15.1-.23.23-.23.41,0,.09.02.17.05.23.03.07.08.12.15.17.07.05.17.11.3.16s.28.11.47.17c.23.08.44.16.63.25.19.09.34.2.47.33.13.12.23.27.3.43.07.16.1.36.1.59,0,.28-.05.52-.16.73-.11.21-.26.39-.44.53s-.42.25-.69.33c-.27.07-.56.11-.89.11-.29,0-.57-.02-.84-.07-.27-.05-.54-.12-.8-.21l.07-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M150.16,63.43v-1.02h1.04v-1.12l1.3-.45v1.56h1.27v1.02h-1.27v2.08c0,.41.05.7.16.89s.33.28.66.28c.17,0,.34-.03.51-.08l.03,1.07c-.13.05-.28.08-.44.11-.16.02-.33.03-.51.03-.61,0-1.05-.16-1.33-.48s-.41-.83-.41-1.53v-2.36h-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M109.71,79.99c-.23.08-.49.13-.78.17s-.59.06-.9.06c-.58,0-1.11-.08-1.59-.25-.48-.16-.89-.41-1.24-.72-.34-.32-.61-.7-.8-1.16-.19-.45-.28-.97-.28-1.55s.1-1.07.29-1.52c.19-.46.46-.84.8-1.16.34-.32.74-.57,1.21-.74s.97-.26,1.52-.26c.31,0,.6.02.88.05.28.03.57.1.87.21l-.1,1.25c-.26-.12-.51-.2-.75-.25-.24-.05-.5-.08-.78-.08-.36,0-.68.05-.98.16s-.54.26-.75.47c-.21.21-.37.46-.49.77-.11.31-.17.66-.17,1.06s.06.76.19,1.07c.12.31.29.58.51.79.22.21.47.37.76.49.29.11.61.16.94.16.26,0,.52-.02.77-.06s.53-.11.82-.22l.05,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M111.65,74.83l.83,2.58c.08.22.15.48.24.78.09.3.17.58.24.86h.02c.08-.28.16-.56.24-.86.09-.29.17-.55.24-.78l.83-2.58h1.39l-2.1,5.7c-.1.28-.22.53-.35.77-.13.23-.28.44-.45.61s-.37.31-.6.4c-.23.1-.49.14-.78.14-.17,0-.35-.01-.53-.04s-.33-.06-.46-.1l.1-1.04c.21.07.44.1.68.1.23,0,.42-.07.59-.22.17-.14.3-.4.41-.78l-2.06-5.56h1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M117.84,79.3c0,.15,0,.31-.01.47,0,.16-.02.29-.03.39h-1.28c.02-.22.03-.47.04-.75,0-.28,0-.56,0-.84v-6.23h1.36v1.84c0,.26,0,.53,0,.79,0,.26-.01.49-.03.69h.02c.2-.31.45-.55.75-.71s.64-.24,1.04-.24c.34,0,.64.07.92.2.27.13.51.32.7.57.19.24.34.53.44.87.1.34.15.7.15,1.1s-.05.8-.16,1.14c-.11.35-.26.65-.46.89-.2.25-.44.44-.73.59-.29.14-.61.21-.96.21-.41,0-.75-.09-1.04-.26-.29-.17-.52-.41-.7-.72h-.02ZM119.27,75.78c-.2,0-.38.04-.54.13-.16.09-.3.21-.42.36-.12.16-.21.34-.27.54-.06.21-.09.43-.09.68s.03.47.09.68c.06.21.15.39.26.54.11.15.25.27.41.36.16.09.34.13.54.13.4,0,.71-.16.93-.48.22-.32.33-.73.33-1.24s-.11-.92-.31-1.24c-.21-.31-.52-.47-.93-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M124.15,77.88c.01.41.17.74.47.98s.69.36,1.17.36c.3,0,.57-.04.83-.12.26-.08.5-.18.72-.32l.02,1.14c-.23.11-.49.2-.78.26-.3.06-.61.09-.95.09-.43,0-.83-.06-1.19-.19-.36-.12-.66-.31-.91-.55-.25-.24-.45-.54-.58-.88-.14-.35-.21-.75-.21-1.19,0-.4.06-.77.19-1.11.13-.34.31-.63.54-.87.23-.24.51-.44.84-.57.33-.14.69-.21,1.09-.21.77,0,1.35.23,1.74.7.39.47.59,1.18.59,2.15,0,.04,0,.1,0,.17,0,.07,0,.12-.02.16h-3.56ZM126.46,76.93c0-.43-.1-.75-.3-.95-.2-.2-.47-.29-.82-.29-.3,0-.57.1-.81.31-.24.21-.37.52-.41.93h2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M130.17,75.84c.14-.35.33-.63.58-.83.25-.2.57-.31.94-.31.08,0,.16,0,.23,0,.07,0,.15.03.22.05l-.03,1.19c-.14-.05-.3-.07-.47-.07-.92,0-1.38.7-1.38,2.1v2.17h-1.4v-3.75c0-.28,0-.56,0-.84,0-.28-.02-.52-.04-.74h1.3c0,.06.01.14.02.22,0,.09,0,.18,0,.27,0,.09,0,.19.01.28,0,.09,0,.17,0,.24h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M132.69,78.91c.26.12.52.22.77.27.25.06.49.09.73.09s.44-.05.61-.14c.17-.09.26-.24.26-.43,0-.09-.01-.17-.05-.24-.03-.07-.09-.13-.16-.2-.08-.06-.18-.12-.31-.18-.13-.06-.31-.12-.52-.2-.51-.17-.87-.37-1.09-.61-.22-.23-.33-.54-.33-.94,0-.25.05-.48.15-.68s.24-.37.43-.51.41-.25.66-.33c.26-.08.55-.12.86-.12.56,0,1.04.08,1.44.25l-.12,1.04c-.44-.2-.86-.3-1.27-.3-.23,0-.43.05-.58.14-.15.1-.23.23-.23.41,0,.09.02.17.05.23.03.07.08.12.15.17.07.05.17.11.3.16s.28.11.47.17c.23.08.44.16.63.25.19.09.34.2.47.33.13.12.23.27.3.43.07.16.1.36.1.59,0,.28-.05.52-.16.73-.11.21-.26.39-.44.53s-.42.25-.69.33c-.27.07-.56.11-.89.11-.29,0-.57-.02-.84-.07-.27-.05-.54-.12-.8-.21l.07-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M138.62,77.88c.01.41.17.74.47.98s.69.36,1.17.36c.3,0,.57-.04.83-.12.26-.08.5-.18.72-.32l.02,1.14c-.23.11-.49.2-.78.26-.3.06-.61.09-.95.09-.43,0-.83-.06-1.19-.19-.36-.12-.66-.31-.91-.55-.25-.24-.45-.54-.58-.88-.14-.35-.21-.75-.21-1.19,0-.4.06-.77.19-1.11.13-.34.31-.63.54-.87.23-.24.51-.44.84-.57.33-.14.69-.21,1.09-.21.77,0,1.35.23,1.74.7.39.47.59,1.18.59,2.15,0,.04,0,.1,0,.17,0,.07,0,.12-.02.16h-3.56ZM140.93,76.93c0-.43-.1-.75-.3-.95-.2-.2-.47-.29-.82-.29-.3,0-.57.1-.81.31-.24.21-.37.52-.41.93h2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M146.82,75.97c-.12-.06-.25-.1-.38-.12s-.28-.04-.45-.04c-.26,0-.49.05-.69.13s-.36.21-.5.36c-.13.15-.24.33-.3.53-.07.2-.1.42-.1.66s.03.46.09.67c.06.2.16.38.29.53.13.15.3.27.51.35.2.08.44.12.73.12.16,0,.31-.01.45-.04.14-.03.29-.08.44-.14l.07,1.09c-.18.06-.36.1-.53.12-.17.03-.37.04-.6.04-.44,0-.84-.07-1.2-.19s-.66-.31-.92-.54-.45-.52-.59-.85c-.14-.34-.21-.71-.21-1.12s.08-.81.23-1.15c.15-.34.36-.63.62-.87s.57-.42.91-.54c.35-.12.72-.18,1.11-.18.22,0,.42,0,.59.03.18.02.35.06.51.12l-.1,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M151.76,79.28c-.17.28-.4.51-.69.71-.29.2-.67.3-1.13.3-.28,0-.54-.05-.77-.14-.23-.1-.43-.24-.59-.42-.16-.18-.29-.4-.37-.66-.09-.25-.13-.54-.13-.85v-3.38h1.36v2.76c0,.24.01.45.04.64.03.19.08.35.15.49.08.13.18.24.31.32.13.08.3.12.5.12s.38-.04.53-.13c.15-.09.29-.2.4-.35.11-.15.19-.32.25-.53.05-.2.08-.42.08-.65v-2.66h1.37v3.75c0,.28,0,.56,0,.84,0,.28.02.53.05.75h-1.29c-.01-.11-.02-.24-.03-.39,0-.15,0-.31,0-.49h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M155.86,75.84c.14-.35.33-.63.58-.83.25-.2.57-.31.94-.31.08,0,.16,0,.23,0,.07,0,.15.03.22.05l-.03,1.19c-.14-.05-.3-.07-.47-.07-.92,0-1.38.7-1.38,2.1v2.17h-1.4v-3.75c0-.28,0-.56,0-.84,0-.28-.02-.52-.04-.74h1.3c0,.06.01.14.02.22,0,.09,0,.18,0,.27,0,.09,0,.19.01.28,0,.09,0,.17,0,.24h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M158.67,73.82v-1.33h1.38v1.33h-1.38ZM158.67,74.83h1.38v5.33h-1.38v-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M160.95,75.85v-1.02h1.04v-1.12l1.3-.45v1.56h1.27v1.02h-1.27v2.08c0,.41.05.7.16.89s.33.28.66.28c.17,0,.34-.03.51-.08l.03,1.07c-.13.05-.28.08-.44.11-.16.02-.33.03-.51.03-.61,0-1.05-.16-1.33-.48s-.41-.83-.41-1.53v-2.36h-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M166.48,74.83l.83,2.58c.08.22.15.48.24.78.09.3.17.58.24.86h.02c.08-.28.16-.56.24-.86.09-.29.17-.55.24-.78l.83-2.58h1.39l-2.1,5.7c-.1.28-.22.53-.35.77-.13.23-.28.44-.45.61s-.37.31-.6.4c-.23.1-.49.14-.78.14-.17,0-.35-.01-.53-.04s-.33-.06-.46-.1l.1-1.04c.21.07.44.1.68.1.23,0,.42-.07.59-.22.17-.14.3-.4.41-.78l-2.06-5.56h1.51Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Beschrieb",
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.07-76.65h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(60.03 -122.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(89 -70)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(23.1 -55.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(16.82 97.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(185.17 -55.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(171.42 95.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(-9.9 217.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(336.19 -54.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(685.78 98.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 112.05,
    y1: -106.41,
    x2: 112.05,
    y2: -79.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "111.03 -105.58 111.22 -105.41 112.05 -106.31 112.89 -105.41 113.08 -105.58 112.05 -106.68 111.03 -105.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "111.03 -79.87 111.22 -80.04 112.05 -79.14 112.89 -80.04 113.08 -79.87 112.05 -78.77 111.03 -79.87"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 109.78,
    y1: -92.73,
    x2: 114.33,
    y2: -92.73
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(34.57 -74.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -99.46,
    x2: 27.07,
    y2: -99.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -86,
    x2: 27.07,
    y2: -86
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.76-97.64h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -97.75,
    x2: 52.68,
    y2: -97.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -94.05,
    x2: 52.68,
    y2: -94.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 37.13,
    y1: -76.72,
    x2: 27.08,
    y2: -76.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 37.13,
    y1: -73.02,
    x2: 27.08,
    y2: -73.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -91.45,
    x2: 52.68,
    y2: -91.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.63,
    y1: -87.75,
    x2: 52.68,
    y2: -87.75
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(48.51 -83.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(97.07 -95.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(97.07 -88.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.57-85.82v3.34h-1.57v-3.34h1.57M52.82-86.07h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M188.14-76.65h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(221.1 -122.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(259.06 -70)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 282.12,
    y1: -106.41,
    x2: 282.12,
    y2: -79.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "281.1 -105.58 281.28 -105.41 282.12 -106.31 282.96 -105.41 283.14 -105.58 282.12 -106.68 281.1 -105.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "281.1 -79.87 281.28 -80.04 282.12 -79.14 282.96 -80.04 283.14 -79.87 282.12 -78.77 281.1 -79.87"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 279.85,
    y1: -92.73,
    x2: 284.39,
    y2: -92.73
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(195.63 -74.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M257.82-94.64h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.69,
    y1: -94.75,
    x2: 213.59,
    y2: -94.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.69,
    y1: -91.05,
    x2: 213.59,
    y2: -91.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 198.19,
    y1: -76.72,
    x2: 188.14,
    y2: -76.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 198.19,
    y1: -73.02,
    x2: 188.14,
    y2: -73.02
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(209.57 -83.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(266.13 -91.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.64-85.89v3.34h-1.57v-3.34h1.57M213.89-86.14h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.39,77.53h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(239.35 31.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(275.31 84.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 298.37,
    y1: 47.77,
    x2: 298.37,
    y2: 75.14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "297.35 48.6 297.53 48.77 298.37 47.87 299.21 48.77 299.39 48.6 298.37 47.5 297.35 48.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "297.35 74.31 297.53 74.14 298.37 75.04 299.21 74.14 299.39 74.31 298.37 75.41 297.35 74.31"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.1,
    y1: 61.45,
    x2: 300.64,
    y2: 61.45
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(181.88 80.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 278.94,
    y1: 54.61,
    x2: 174.39,
    y2: 54.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 278.94,
    y1: 68.07,
    x2: 174.39,
    y2: 68.07
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.08,59.54h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 278.94,
    y1: 59.43,
    x2: 200.14,
    y2: 59.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 278.94,
    y1: 63.13,
    x2: 200.14,
    y2: 63.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 184.44,
    y1: 77.46,
    x2: 174.39,
    y2: 77.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 184.44,
    y1: 81.16,
    x2: 174.39,
    y2: 81.16
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(195.82 70.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(276.39 62.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.89,68.29v3.34h-1.57v-3.34h1.57M200.14,68.04h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.8,77.41h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(53.75 31.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(82.72 84.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 105.78,
    y1: 47.65,
    x2: 105.78,
    y2: 75.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "104.75 48.48 104.94 48.65 105.78 47.75 106.62 48.65 106.8 48.48 105.78 47.38 104.75 48.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "104.75 74.18 104.94 74.01 105.78 74.92 106.62 74.01 106.8 74.18 105.78 75.28 104.75 74.18"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 103.51,
    y1: 61.33,
    x2: 108.05,
    y2: 61.33
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(28.29 80.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 54.6,
    x2: 20.8,
    y2: 54.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 68.06,
    x2: 20.8,
    y2: 68.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.48,56.42h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 56.31,
    x2: 46.4,
    y2: 56.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 60.01,
    x2: 46.4,
    y2: 60.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 30.85,
    y1: 77.34,
    x2: 20.8,
    y2: 77.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 30.85,
    y1: 81.04,
    x2: 20.8,
    y2: 81.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 62.6,
    x2: 46.4,
    y2: 62.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.35,
    y1: 66.3,
    x2: 46.4,
    y2: 66.3
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(42.23 70.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(90.79 59.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(90.79 65.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.3,68.24v3.34h-1.57v-3.34h1.57M46.55,67.99h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(55.21 196.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(26.76 239.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 18.35,
    y1: 237.66,
    x2: 25.11,
    y2: 237.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "19.18 238.69 19.35 238.5 18.44 237.66 19.35 236.82 19.18 236.64 18.08 237.66 19.18 238.69"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(32.84 216.91)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(62.11 222.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(62.11 228.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.8,219.83h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 64.66,
    y1: 219.72,
    x2: 17.71,
    y2: 219.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 64.66,
    y1: 223.43,
    x2: 17.71,
    y2: 223.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 64.66,
    y1: 226.02,
    x2: 17.71,
    y2: 226.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 64.66,
    y1: 229.62,
    x2: 17.71,
    y2: 229.62
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.14,217.98v1.57h-3.34v-1.57h3.34M35.39,217.73h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(-3.73 395.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(61.37 374.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(32.92 417.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 24.51,
    y1: 415.92,
    x2: 31.27,
    y2: 415.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.34 416.94 25.51 416.76 24.61 415.92 25.51 415.08 25.34 414.9 24.24 415.92 25.34 416.94"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(39 395.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(68.27 400.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(68.27 406.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.96,398.09h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 70.83,
    y1: 397.98,
    x2: 23.88,
    y2: 397.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 70.83,
    y1: 401.68,
    x2: 23.88,
    y2: 401.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 70.83,
    y1: 404.27,
    x2: 23.88,
    y2: 404.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 70.83,
    y1: 407.87,
    x2: 23.88,
    y2: 407.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.31,396.24v1.57h-3.34v-1.57h3.34M41.56,395.99h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(168.03 218.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(233.13 197.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(204.68 239.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 196.27,
    y1: 238.21,
    x2: 203.03,
    y2: 238.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "197.1 239.23 197.27 239.04 196.37 238.21 197.27 237.37 197.1 237.18 196 238.21 197.1 239.23"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(210.76 217.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(250.03 223)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.72,220.37h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 252.59,
    y1: 220.27,
    x2: 195.51,
    y2: 220.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 252.59,
    y1: 223.97,
    x2: 195.51,
    y2: 223.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.07,218.52v1.57h-3.34v-1.57h3.34M213.32,218.27h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(173.66 393.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(238.76 372.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(210.31 414.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 221.9,
    y1: 413.26,
    x2: 228.66,
    y2: 413.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "222.73 414.28 222.9 414.1 222 413.26 222.9 412.42 222.73 412.23 221.63 413.26 222.73 414.28"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(216.39 392.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(520.56 409.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(282.66 398.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.35,395.43h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 285.22,
    y1: 395.32,
    x2: 201.27,
    y2: 395.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 285.22,
    y1: 399.02,
    x2: 201.27,
    y2: 399.02
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.7,393.58v1.57h-3.34v-1.57h3.34M218.95,393.33h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(564.49 377.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand zu Hinweis 1,5x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schutzraum 1x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(520.32 377.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(502.89 409.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(502.89 368.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(488.81 371.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(557.6 371.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M494.8,369.1h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 560.15,
    y1: 369.21,
    x2: 487.53,
    y2: 369.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 560.15,
    y1: 372.91,
    x2: 487.53,
    y2: 372.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.62,373.04v1.57h-3.34v-1.57h3.34M522.87,372.79h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(328.69 205.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(393.79 184.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(365.34 227.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 356.93,
    y1: 225.92,
    x2: 363.69,
    y2: 225.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "357.76 226.94 357.93 226.76 357.03 225.92 357.93 225.08 357.76 224.89 356.66 225.92 357.76 226.94"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(367.63 205.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(400.69 210.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(400.69 216.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.38,208.09h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 403.25,
    y1: 207.98,
    x2: 356.3,
    y2: 207.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 403.25,
    y1: 211.68,
    x2: 356.3,
    y2: 211.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 403.25,
    y1: 214.27,
    x2: 356.29,
    y2: 214.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 403.25,
    y1: 217.87,
    x2: 356.29,
    y2: 217.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.93,206.24v1.57h-3.34v-1.57h3.34M370.18,205.99h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(322.34 391.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(387.44 370.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(358.99 412.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 350.58,
    y1: 411.42,
    x2: 357.34,
    y2: 411.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "351.41 412.45 351.58 412.26 350.68 411.43 351.58 410.59 351.41 410.4 350.31 411.43 351.41 412.45"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(361.28 390.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(394.34 396.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(394.34 402.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M386.03,393.59h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 396.9,
    y1: 393.49,
    x2: 349.95,
    y2: 393.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 396.9,
    y1: 397.19,
    x2: 349.95,
    y2: 397.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 396.9,
    y1: 399.78,
    x2: 349.95,
    y2: 399.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 396.9,
    y1: 403.38,
    x2: 349.95,
    y2: 403.38
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.59,391.74v1.57h-3.34v-1.57h3.34M363.84,391.49h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(491.95 75.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(557.05 54.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(528.6 96.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 520.11,
    y1: 95.52,
    x2: 526.87,
    y2: 95.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "520.94 96.54 521.11 96.36 520.2 95.52 521.11 94.68 520.94 94.5 519.84 95.52 520.94 96.54"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(530.89 74.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(573.95 80.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M565.64,77.46h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 576.51,
    y1: 77.35,
    x2: 519.43,
    y2: 77.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 576.51,
    y1: 81.05,
    x2: 519.43,
    y2: 81.05
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M533.2,75.61v1.57h-3.34v-1.57h3.34M533.45,75.36h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(488.35 230.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(553.46 209.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(525 252.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "linksb\xFCndig")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 516.59,
    y1: 250.75,
    x2: 523.35,
    y2: 250.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "517.42 251.77 517.59 251.59 516.69 250.75 517.59 249.91 517.42 249.72 516.32 250.75 517.42 251.77"
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(527.29 229.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(597.36 235.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M589.05,232.91h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 599.91,
    y1: 232.8,
    x2: 515.96,
    y2: 232.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 599.91,
    y1: 236.51,
    x2: 515.96,
    y2: 236.51
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M529.6,231.07v1.57h-3.34v-1.57h3.34M529.85,230.82h-3.84v2.07h3.84v-2.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M342.14-73.86h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(375.1 -119.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(404.06 -74.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 427.12,
    y1: -96.61,
    x2: 427.12,
    y2: -83.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "426.1 -95.78 426.28 -95.61 427.12 -96.52 427.96 -95.61 428.14 -95.78 427.12 -96.88 426.1 -95.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "426.1 -84.31 426.28 -84.48 427.12 -83.58 427.96 -84.48 428.14 -84.31 427.12 -83.21 426.1 -84.31"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 424.85,
    y1: -89.94,
    x2: 429.39,
    y2: -89.94
  })), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(567.45 -75.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 590.51,
    y1: -98.29,
    x2: 590.51,
    y2: -85.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "589.49 -97.46 589.67 -97.29 590.51 -98.2 591.35 -97.29 591.53 -97.46 590.51 -98.56 589.49 -97.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "589.49 -85.99 589.67 -86.16 590.51 -85.26 591.35 -86.16 591.53 -85.99 590.51 -84.89 589.49 -85.99"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 588.24,
    y1: -91.62,
    x2: 592.78,
    y2: -91.62
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(349.63 -71.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 414.69,
    y1: -96.67,
    x2: 342.14,
    y2: -96.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 414.69,
    y1: -83.21,
    x2: 342.14,
    y2: -83.21
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M400.18-94.86h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 411.05,
    y1: -94.97,
    x2: 364.1,
    y2: -94.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 411.05,
    y1: -91.27,
    x2: 364.1,
    y2: -91.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 352.19,
    y1: -73.94,
    x2: 342.14,
    y2: -73.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 352.19,
    y1: -70.24,
    x2: 342.14,
    y2: -70.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 411.05,
    y1: -88.67,
    x2: 364.1,
    y2: -88.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 411.05,
    y1: -84.97,
    x2: 364.1,
    y2: -84.97
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(359.93 -80.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(408.49 -92.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(408.49 -85.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364-83.03v3.34h-1.57v-3.34h1.57M364.25-83.28h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M501.49-75.54h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(534.45 -121.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(508.98 -72.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 578.41,
    y1: -98.47,
    x2: 501.49,
    y2: -98.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 578.41,
    y1: -85.01,
    x2: 501.49,
    y2: -85.01
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M567.54-93.54h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 578.41,
    y1: -93.65,
    x2: 523.31,
    y2: -93.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 578.41,
    y1: -89.95,
    x2: 523.31,
    y2: -89.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 511.54,
    y1: -75.62,
    x2: 501.49,
    y2: -75.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 511.54,
    y1: -71.91,
    x2: 501.49,
    y2: -71.91
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(519.29 -82.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(575.85 -90.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M523.36-84.78v3.34h-1.57v-3.34h1.57M523.61-85.03h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M691.73,78.47h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(724.69 32.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(753.66 78.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 776.71,
    y1: 55.72,
    x2: 776.71,
    y2: 68.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "775.69 56.55 775.87 56.72 776.71 55.81 777.55 56.72 777.74 56.55 776.71 55.45 775.69 56.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "775.69 68.02 775.87 67.85 776.71 68.75 777.55 67.85 777.74 68.02 776.71 69.12 775.69 68.02"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 774.44,
    y1: 62.39,
    x2: 778.99,
    y2: 62.39
  })), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(756.55 -79.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 779.61,
    y1: -102.16,
    x2: 779.61,
    y2: -89.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "778.59 -101.33 778.77 -101.16 779.61 -102.06 780.45 -101.16 780.64 -101.33 779.61 -102.43 778.59 -101.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "778.59 -89.86 778.77 -90.03 779.61 -89.13 780.45 -90.03 780.64 -89.86 779.61 -88.76 778.59 -89.86"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 777.34,
    y1: -95.49,
    x2: 781.88,
    y2: -95.49
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(699.23 81.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 764.29,
    y1: 55.66,
    x2: 691.73,
    y2: 55.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 764.29,
    y1: 69.12,
    x2: 691.73,
    y2: 69.12
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M749.78,57.47h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 760.65,
    y1: 57.36,
    x2: 713.69,
    y2: 57.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 760.65,
    y1: 61.06,
    x2: 713.69,
    y2: 61.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 701.78,
    y1: 78.39,
    x2: 691.74,
    y2: 78.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 701.78,
    y1: 82.1,
    x2: 691.74,
    y2: 82.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 760.65,
    y1: 63.66,
    x2: 713.69,
    y2: 63.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 760.65,
    y1: 67.36,
    x2: 713.69,
    y2: 67.36
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(709.52 71.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(758.09 60.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(758.09 66.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M713.59,69.3v3.34h-1.57v-3.34h1.57M713.84,69.05h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M666.59-79.41h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(699.55 -125.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(674.08 -76.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 767.52,
    y1: -102.34,
    x2: 666.59,
    y2: -102.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 767.52,
    y1: -88.88,
    x2: 666.59,
    y2: -88.88
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M756.65-97.41h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 767.52,
    y1: -97.52,
    x2: 712.42,
    y2: -97.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 767.52,
    y1: -93.81,
    x2: 712.42,
    y2: -93.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 676.64,
    y1: -79.48,
    x2: 666.59,
    y2: -79.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 676.64,
    y1: -75.78,
    x2: 666.59,
    y2: -75.78
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(684.39 -86.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(764.96 -94.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M688.46-88.65v3.34h-1.57v-3.34h1.57M688.71-88.9h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 90.25,
    y1: -113.4,
    x2: 90.25,
    y2: -101.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 48.8,
    y1: -79.04,
    x2: 48.8,
    y2: -55.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 42.53,
    y1: 74.36,
    x2: 42.53,
    y2: 97.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 210.87,
    y1: -79.04,
    x2: 210.87,
    y2: -55.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 197.12,
    y1: 73.48,
    x2: 197.12,
    y2: 97.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 361.89,
    y1: -78.02,
    x2: 361.89,
    y2: -54.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 711.48,
    y1: 75.33,
    x2: 711.48,
    y2: 98.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 52.68,
    y1: -99.67,
    x2: 52.68,
    y2: -85.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 251.32,
    y1: -113.4,
    x2: 251.32,
    y2: -101.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 213.74,
    y1: -99.67,
    x2: 213.74,
    y2: -85.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 269.57,
    y1: 40.78,
    x2: 269.57,
    y2: 52.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 199.99,
    y1: 54.51,
    x2: 199.99,
    y2: 68.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 83.98,
    y1: 40.66,
    x2: 83.98,
    y2: 52.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 46.4,
    y1: 54.39,
    x2: 46.4,
    y2: 68.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 55.21,
    y1: 204.64,
    x2: 55.21,
    y2: 216.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 17.72,
    y1: 214.14,
    x2: 17.72,
    y2: 237.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 61.37,
    y1: 382.89,
    x2: 61.37,
    y2: 394.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 23.88,
    y1: 392.39,
    x2: 23.88,
    y2: 415.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 233.13,
    y1: 205.18,
    x2: 233.13,
    y2: 217.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 195.64,
    y1: 214.68,
    x2: 195.64,
    y2: 238.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 238.76,
    y1: 380.23,
    x2: 238.76,
    y2: 392.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 201.27,
    y1: 389.73,
    x2: 201.27,
    y2: 413.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 505.32,
    y1: 365.48,
    x2: 505.32,
    y2: 410.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 393.79,
    y1: 192.89,
    x2: 393.79,
    y2: 204.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 356.3,
    y1: 198.44,
    x2: 356.3,
    y2: 225.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 387.44,
    y1: 378.4,
    x2: 387.44,
    y2: 390.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 350.05,
    y1: 383.95,
    x2: 349.97,
    y2: 411.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 557.05,
    y1: 62.26,
    x2: 557.05,
    y2: 74.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 519.66,
    y1: 67.82,
    x2: 519.58,
    y2: 95.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 553.46,
    y1: 217.72,
    x2: 553.46,
    y2: 229.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 515.96,
    y1: 223.27,
    x2: 515.96,
    y2: 250.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 405.32,
    y1: -110.61,
    x2: 405.32,
    y2: -98.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 364.1,
    y1: -96.88,
    x2: 364.1,
    y2: -83.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 358.81,
    y1: -96.88,
    x2: 358.81,
    y2: -83.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 564.67,
    y1: -112.29,
    x2: 564.67,
    y2: -100.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 523.46,
    y1: -98.56,
    x2: 523.46,
    y2: -84.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 518.17,
    y1: -98.56,
    x2: 518.17,
    y2: -85.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 754.91,
    y1: 41.72,
    x2: 754.91,
    y2: 53.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 713.69,
    y1: 55.45,
    x2: 713.69,
    y2: 69.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 708.4,
    y1: 55.45,
    x2: 708.4,
    y2: 69.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 729.77,
    y1: -116.16,
    x2: 729.77,
    y2: -104.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 688.56,
    y1: -102.43,
    x2: 688.56,
    y2: -88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 683.27,
    y1: -102.43,
    x2: 683.27,
    y2: -88.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 559.95,
    y1: 378.44,
    x2: 505.32,
    y2: 378.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.69,
    y1: -99.57,
    x2: 188.14,
    y2: -99.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.69,
    y1: -86.11,
    x2: 188.14,
    y2: -86.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 37.01,
    y1: -73.06,
    x2: 37.01,
    y2: -86.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 33.41,
    y1: -73.06,
    x2: 33.41,
    y2: -86.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.87-76.54v3.34h-3.34v-3.34h3.34M37.12-76.79h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.81-85.82v3.34h-3.34v-3.34h3.34M51.06-86.07h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.38-97.54v3.34h-3.34v-3.34h3.34M99.63-97.79h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.38-91.26v3.34h-3.34v-3.34h3.34M99.63-91.51h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 198.08,
    y1: -73.06,
    x2: 198.08,
    y2: -86.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 194.47,
    y1: -73.06,
    x2: 194.47,
    y2: -86.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.94-76.54v3.34h-3.34v-3.34h3.34M198.19-76.79h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.88-85.89v3.34h-3.34v-3.34h3.34M212.13-86.14h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.44-94.51v3.34h-3.34v-3.34h3.34M268.69-94.76h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 184.33,
    y1: 81.12,
    x2: 184.33,
    y2: 68.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 180.72,
    y1: 81.12,
    x2: 180.72,
    y2: 68.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.19,77.64v3.34h-3.34v-3.34h3.34M184.44,77.39h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.13,68.29v3.34h-3.34v-3.34h3.34M198.38,68.04h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.69,59.67v3.34h-3.34v-3.34h3.34M278.94,59.42h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 30.73,
    y1: 81,
    x2: 30.73,
    y2: 67.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.13,
    y1: 81,
    x2: 27.13,
    y2: 67.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.6,77.52v3.34h-3.34v-3.34h3.34M30.85,77.27h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.54,68.24v3.34h-3.34v-3.34h3.34M44.79,67.99h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.1,56.52v3.34h-3.34v-3.34h3.34M93.35,56.27h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.1,62.8v3.34h-3.34v-3.34h3.34M93.35,62.55h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 35.28,
    y1: 217.86,
    x2: 35.28,
    y2: 204.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 31.68,
    y1: 217.86,
    x2: 31.68,
    y2: 204.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.14,214.39v3.34h-3.34v-3.34h3.34M35.39,214.14h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.41,219.94v3.34h-3.34v-3.34h3.34M64.66,219.69h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.41,226.16v3.34h-3.34v-3.34h3.34M64.66,225.91h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 41.44,
    y1: 396.12,
    x2: 41.44,
    y2: 383.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 37.84,
    y1: 396.12,
    x2: 37.84,
    y2: 383.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.31,392.64v3.34h-3.34v-3.34h3.34M41.56,392.39h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.58,398.19v3.34h-3.34v-3.34h3.34M70.83,397.94h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.58,404.41v3.34h-3.34v-3.34h3.34M70.83,404.16h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 213.2,
    y1: 218.4,
    x2: 213.2,
    y2: 205.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 209.6,
    y1: 218.4,
    x2: 209.6,
    y2: 205.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.07,214.93v3.34h-3.34v-3.34h3.34M213.32,214.68h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.34,220.48v3.34h-3.34v-3.34h3.34M252.59,220.23h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 218.83,
    y1: 393.46,
    x2: 218.83,
    y2: 380.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 215.23,
    y1: 393.46,
    x2: 215.23,
    y2: 380.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.7,389.98v3.34h-3.34v-3.34h3.34M218.95,389.73h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 523.01,
    y1: 410.14,
    x2: 523.01,
    y2: 398.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 519.41,
    y1: 410.14,
    x2: 519.41,
    y2: 398.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.87,406.66v3.34h-3.34v-3.34h3.34M523.12,406.41h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.97,395.53v3.34h-3.34v-3.34h3.34M285.22,395.28h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.62,374.86v3.34h-3.34v-3.34h3.34M522.87,374.61h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M505.19,406.66v3.34h-3.34v-3.34h3.34M505.44,406.41h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M505.19,365.73v3.34h-3.34v-3.34h3.34M505.44,365.48h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491.12,369.42v3.34h-3.34v-3.34h3.34M491.37,369.17h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.9,369.42v3.34h-3.34v-3.34h3.34M560.15,369.17h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.93,202.64v3.34h-3.34v-3.34h3.34M370.18,202.39h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403,208.19v3.34h-3.34v-3.34h3.34M403.25,207.94h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403,214.41v3.34h-3.34v-3.34h3.34M403.25,214.16h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.59,388.15v3.34h-3.34v-3.34h3.34M363.84,387.9h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.65,393.7v3.34h-3.34v-3.34h3.34M396.9,393.45h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.65,399.92v3.34h-3.34v-3.34h3.34M396.9,399.67h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M533.2,72.01v3.34h-3.34v-3.34h3.34M533.45,71.76h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M576.26,77.57v3.34h-3.34v-3.34h3.34M576.51,77.32h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M529.6,227.47v3.34h-3.34v-3.34h3.34M529.85,227.22h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.66,233.02v3.34h-3.34v-3.34h3.34M599.91,232.77h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 352.08,
    y1: -70.28,
    x2: 352.08,
    y2: -83.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 348.47,
    y1: -70.28,
    x2: 348.47,
    y2: -83.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351.94-73.76v3.34h-3.34v-3.34h3.34M352.19-74.01h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.24-83.03v3.34h-3.34v-3.34h3.34M362.49-83.28h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.8-94.75v3.34h-3.34v-3.34h3.34M411.05-95h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.8-88.48v3.34h-3.34v-3.34h3.34M411.05-88.73h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 511.43,
    y1: -71.96,
    x2: 511.43,
    y2: -85.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 507.82,
    y1: -71.96,
    x2: 507.82,
    y2: -85.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M511.29-75.44v3.34h-3.34v-3.34h3.34M511.54-75.69h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M521.6-84.78v3.34h-3.34v-3.34h3.34M521.85-85.03h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M578.16-93.41v3.34h-3.34v-3.34h3.34M578.41-93.66h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 701.67,
    y1: 82.05,
    x2: 701.67,
    y2: 68.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 698.07,
    y1: 82.05,
    x2: 698.07,
    y2: 68.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M701.53,78.57v3.34h-3.34v-3.34h3.34M701.78,78.32h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M711.83,69.3v3.34h-3.34v-3.34h3.34M712.08,69.05h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M760.39,57.58v3.34h-3.34v-3.34h3.34M760.64,57.33h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M760.39,63.85v3.34h-3.34v-3.34h3.34M760.64,63.6h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(342.09 98.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abstand 1,5x")), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.04,78.47h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(381 32.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frutiger Bold, Versalh\xF6he H = 1x"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.5
  }, "Schriftgr\xF6sse zu Zeilenabstand 1:1,2 ")), /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(409.96 78.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schrift mittig "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.05,
    y: 5.5
  }, "platziert zu Logo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 433.02,
    y1: 55.72,
    x2: 433.02,
    y2: 68.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "432 56.55 432.18 56.72 433.02 55.81 433.86 56.72 434.04 56.55 433.02 55.45 432 56.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "432 68.02 432.18 67.85 433.02 68.75 433.86 67.85 434.04 68.02 433.02 69.12 432 68.02"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 430.75,
    y1: 62.39,
    x2: 435.29,
    y2: 62.39
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(355.53 81.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 420.59,
    y1: 55.66,
    x2: 348.04,
    y2: 55.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 420.59,
    y1: 69.12,
    x2: 348.04,
    y2: 69.12
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.08,57.47h.71s0,1.41,0,1.41h1.41v-1.41s.71,0,.71,0v3.55s-.71,0-.71,0v-1.54h-1.41v1.54s-.71,0-.71,0v-3.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.95,
    y1: 57.36,
    x2: 370,
    y2: 57.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.95,
    y1: 61.06,
    x2: 370,
    y2: 61.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 358.09,
    y1: 78.39,
    x2: 348.04,
    y2: 78.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 358.09,
    y1: 82.1,
    x2: 348.04,
    y2: 82.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.95,
    y1: 63.66,
    x2: 370,
    y2: 63.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.95,
    y1: 67.36,
    x2: 370,
    y2: 67.36
  })), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(365.83 71.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(414.39 60.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(414.39 66.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.89,69.3v3.34h-1.57v-3.34h1.57M370.14,69.05h-2.07v3.84h2.07v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 367.79,
    y1: 75.33,
    x2: 367.79,
    y2: 98.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 411.22,
    y1: 41.72,
    x2: 411.22,
    y2: 53.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 370,
    y1: 55.45,
    x2: 370,
    y2: 69.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 364.71,
    y1: 55.45,
    x2: 364.71,
    y2: 69.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 357.97,
    y1: 82.05,
    x2: 357.97,
    y2: 68.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 354.37,
    y1: 82.05,
    x2: 354.37,
    y2: 68.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M357.84,78.57v3.34h-3.34v-3.34h3.34M358.09,78.32h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.13,69.3v3.34h-3.34v-3.34h3.34M368.38,69.05h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.7,57.58v3.34h-3.34v-3.34h3.34M416.95,57.33h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.7,63.85v3.34h-3.34v-3.34h3.34M416.95,63.6h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 676.53,
    y1: -75.83,
    x2: 676.53,
    y2: -88.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 672.93,
    y1: -75.83,
    x2: 672.93,
    y2: -88.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M676.39-79.31v3.34h-3.34v-3.34h3.34M676.64-79.56h-3.84v3.84h3.84v-3.84h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M686.7-88.65v3.34h-3.34v-3.34h3.34M686.95-88.9h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M767.27-97.28v3.34h-3.34v-3.34h3.34M767.52-97.53h-3.84v3.84h3.84v-3.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.9,365.73v44.27h-58.05v-44.27h58.05M560.15,365.48h-58.55v44.77h58.55v-44.77h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpcsLogo);
export default __webpack_public_path__ + "static/media/spcs_logo.11ff8fbf689694cb92bc5c54b6a173c9.svg";
export { ForwardRef as ReactComponent };